export default {
  LIST_PAGE: {
    TITLE: `Audit Log`,
    SUMMARY: ``
  },
  BY: `By`,
  ACTION: `Action`,
  DATE: `Date`,
  ON_THE: 'on the',
  ON: 'on',
  TO: 'to',
  OF: 'of',
  FOR: 'for',
  FROM: 'from',
  AND: 'and',
  AT: `at`,
  UPDATED: 'updated',
  UPDATED_BULLETIN: 'updated the bulletin',
  CREATED_BULLETIN: 'created the bulletin',
  DELETED_BULLETIN: 'deleted the bulletin',
  TRIED_TO: 'Tried to',
  CONNECT_TO: 'connect to the server',
  INVALID_USERNAME: 'with an invalid username',
  INVALID_PASSWORD: 'with an invalid password',
  INVALID_TOKEN: 'with an invalid token',
  INVALID_EMAIL: 'invalid email',
  ERROR_GENERATING_TEMPLATE: 'error generating email',
  USERNAME_RECOVERY_REQUESTED: 'Username recovery requested',
  USERNAME_RECOVERY: 'for recovering a username',
  USERNAME_EMAIL_NOT_FOUND: 'with a username or email not found',
  EMAIL_NOT_FOUND: 'with an email not found',
  NO_TOKEN: 'with no token',
  SUCCESS: 'successfully',
  ATTEMPT_LIMIT: 'has reached the attempt limit',
  RENEWED_TOKEN: 'renewed token',
  ADDED: 'added',
  WAS_ADDED: 'was added',
  WAS_UPDATED: 'was updated',
  WAS_DELETED: 'was deleted',
  REMOVED: 'removed',
  CONFIRMED: 'acknowledged',
  MANUALLY_CONFIRMED: 'manually acknowledged',
  NEW_DEPARTMENTS: 'new departments',
  DEPARTMENTS: 'the department',
  AVAILABILITIES: 'availabilities',
  NEW_LEAVE: 'a new attendance request',
  LEAVE: 'an attendance request',
  APPROVED: 'approved',
  REFUSED: 'Refused',
  CANCELLED: 'Cancelled',
  RESTORED: 'Restored',
  APPROVED_STATUS: 'approved',
  REFUSED_STATUS: 'refused',
  CANCELLED_STATUS: 'cancelled',
  ACKNOWLEDGED_STATUS: 'acknowledged',
  JUSTIFIED_STATUS: 'marked as justified',
  UNJUSTIFIED_STATUS: 'marked as unjustified',
  PERMISSION: 'permission',
  PERMISSIONS: 'permissions',
  NEW_PERMISSION: 'new permission',
  PROJECT: 'a project',
  NEW_PROJECT: 'a new project:',
  SHIFTS: 'shifts',
  NEW_ATTRIBUTE_LEVEL: 'a new attribute level',
  ATTRIBUTE_LEVEL: 'an attribute level',
  ATTRIBUTE: 'an attribute',
  STRUCTURE: 'structure',
  STRUCTURE_ATTRIBUTE: 'structure attribute',
  HIRING_DATA: 'the hiring data',
  VALIDATED_INFO: 'validated their information',
  EMPLOYEE_ATTRIBUTE: 'the employee attribute',
  NEW_TIME_OFF: 'a new time off',
  TIME_OFF: 'a time off',
  OVERTIME_LIST: 'an overtime list',
  ERROR: 'Error',
  CREATING_RANDOM_TOKEN: 'creating random token',
  PASSWORD_RESET: 'for a password reset',
  FORCE_RESEND: 'has force resent shift notifications(s) for ',
  SENT_CONFIRMATIONS: 'has sent shift notifications(s) for ',
  SENT_CANCELLATION_NOTICE: 'has sent shift cancellation notices for ',
  CONFIRMATION_SHIFT_SENT: 'Confirmation email sent',
  NO_EMAIL: 'has no email',
  SENDING_EMAIL: 'sending email',
  EVENT: 'an event',
  RESOURCE_NAME: 'resource name',
  IF_APPLICABLE: 'if applicable',
  RESOURCE_Id: 'resource Id',
  NEW_USERS: 'new users',
  REGISTERED_DEVICE: 'registered a device',
  PHONE_OF: 'The telephone of',
  LIST_PAUSED: 'list is currently paused',
  START: 'started an overtime list',
  FORCED_PAUSE: 'forced pause on an overtime list',
  ARCHIVED_LIST: 'archived overtime list',
  DELETED_LIST: 'deleted overtime list',
  CHANGED: 'changed',
  LIST_STATUS: 'a list status',
  PERMITTED_LISTS: 'permitted lists',
  LIST_TYPE: 'list type',
  STATUS: 'the status',
  TO_OFFER: 'to offer',
  HISTORY: 'history',
  LOCKED_CALLS: 'locked calls',
  UNLOCKED_CALLS: 'unlocked calls',
  NOTIFICATIONS: 'notifications',
  LIST: 'list',
  BIDS: 'bids',
  NEW_EVENTS: 'new events',
  IMPORTED: 'imported',
  NEW_TEMPLATE: 'a new template',
  TEMPLATE: 'template',
  APPLIED: 'applied',
  ABSENCE: 'an absence',
  BY_TELEPHONE: 'by telephone',
  LATE_REQUEST: 'a late request',
  CHECKED_MESSAGES: 'checked messages',
  USER: 'a user',
  NOT_WORKING: 'does not work',
  MINUTE: 'minute',
  DELAY_BEFORE_NEXT_CALL: 'delay before next call',
  DELAY_BETWEEN_CALLS: 'delay between calls',
  EXPIRED: 'expired',
  SHIFT_CONFIRMATION_EMAIL: 'the shift confirmation email',
  GET_SETTINGS: 'get settings',
  GET_USER_INFORMATION: 'get user information',
  NEW_CLIENT: 'a new client',
  CLIENT: 'client',
  INFORMATION: 'the information',
  UNAPPROVED_SHIFT: 'unapproved shift(s)',
  APPROVED_SHIFT: 'approved shift(s)',
  INDEX: 'index',
  CREATED: 'created',
  HIS_SETTING: 'their setting',
  DELETED: 'deleted',
  REQUEST_FIELD: 'request field',
  SAVED: 'saved',
  NEW_VACATION_DISTRIBUTION: 'new vacation distribution',
  APP_SETTING: 'application setting',
  IMPORT_CONFIG: 'import config',
  UPLOADED: 'uploaded',
  ATTRIBUTE_FILE: 'attribute file',
  VACATION_DISTRIBUTION: 'vacation distribution',
  NEW_VACATION_DISTRIBUTION_CHOICE: 'new vacation distribution choice',
  FILTER_MODULE: 'filter module',
  NOTIFICATION: 'notification',
  CALLED_HOTLINE: 'called the hotline',
  INVALID_EMPLOYEE_NUMBER: 'invalide employee number',
  LOGGED_IN: 'logged in',
  WITH_PIN: 'with a PIN',
  RENEWE_TOKEN: 'renewed a token',
  NEW_VACATION: 'new vacation',
  ATTRIBUTE_URL: 'attribute url',
  EMPLOYEE_NUMBER_ONLY: 'with is employee number',
  VACATION_DISTRIBUTION_CHOICE: 'his vacation choice',
  SHIFT_SWAP: 'a shift swap',
  CANCEL_SHIFT_SENT: 'Cancellation email sent ',
  EMAIL_BATCH_COMPLETED: 'Email batch completed',
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
  EVENTS: 'events',
  TOTAL: 'Total',
  MADE_NO_CHANGES: 'made no changes',
  FAILED_TO_SEND_EMAIL_TO: 'Failed to send email to ',
  ARCHIVED: 'archived',
  UNARCHIVED: 'unarchived',
  PAUSED: 'paused',
  STARTED: 'started',
  MERGED: 'merged',
  RESUMEED: 'resumed',
  IN_PUNCH_TERMINAL: ' in the punch terminal',
  PUNCHED: 'punched',
  PUNCH_CARD: 'punch card',
  LAUNCHED: 'launched a',
  PUNCH_TERMINAL: 'Punch Terminal',
  PUNCHED_IN: 'punched in',
  PUNCHED_OUT: 'punched out',
  NEW_TEAM: 'a new team',
  TEAM: 'team',
  PHONE_NUMBERS: 'Phone numbers',
  EMAILS: 'Emails',
  PICTURE: 'Picture',
  PASSWORD_WAS_RESET: 'Password was reset',
  PASSWORD_RESET_REQUESTED: 'Password reset requested',
  COMPANY_URL_REQUESTED: 'Company URL requested',
  COMMENT: 'comment',
  FILTER_BY_DATES: 'Filter the logs by date and time',
  RECEIVED_SHIFT_CONFIRMATION_CALL: 'received a shift notification call at',
  FOR_SHIFT_CONFIRMATION: 'for shift notification',
  RECEIVED_AN_EMAIL_TO: 'received an email at',
  TO_CONFIRM_SHIFT: 'to notify shift(s)',
  FOR_CANCELLED_SHIFT: 'for cancelled shift(s)',
  NEED_USERNAME: '(Username input required, multiple users have this email)',
  SAME_EMAIL_CONTACT_MANAGER: 'but a manager is needed (multiple accounts with same email)',
  TEAMS: 'the team',
  REGION_TAGS: 'the region tag',
  SORT_MODULE: 'sort module',
  TAG: 'tag',
  NEW_TAG: 'new tag',
  SCHEDULE_TYPE: `a schedule type`,
  POSITIONS: `a positions`,
  PUNCH_RULES: `a punch rules`,
  WAGE_PREMIUM: `a wage premium`,
  CONTACT_TEMPLATE: `a contact template (notification)`,
  MODULE: `Module`,
  modules: {
    attributeLevel: `Attribute levels`,
    attributes: `Attributes`,
    authentication: `Authentification`,
    availability: `Availabilities`,
    billing: `Billing`,
    bulletin: `Bulletins`,
    clients: `Clients`,
    contactListConfigss: `Contact list config`,
    contactLists: `Contact lists`,
    contactTemplates: `Contact list notification templates`,
    departmentModification: `Department modifications`,
    departments: `Departments`,
    emails: `Emails`,
    finalize: `Finalize`,
    generateSchedule: `Auto scheduling`,
    groupsPermission: `Permission's group`,
    hiringData: `Hiring data`,
    leave: `Attendances`,
    pay: `Pay`,
    permissions: `Permissions`,
    projects: `Projects`,
    punch: `Punch`,
    punchRules: `Punch rules`,
    regionalTags: `Regional tags`,
    requestsFields: `Requests fields`,
    resolve: `Schedule issues resolution`,
    schedule: `Schedule`,
    scheduleConfirmation: `Schedule notifications`,
    scheduleTemplate: `Schedule templates`,
    scheduleTypes: `Schedule types`,
    settings: `Settings`,
    'shift-cancellation-email': `Shift cancellation email`,
    'shift-confirmation-email': `Shift notification email`,
    'shift-confirmation-phone': `Shift notification call`,
    structure: `Positions`,
    structureAttributes: `Position's attributes`,
    tags: `Tags`,
    teams: `Teams`,
    twilio: `Call system`,
    user: `Users`,
    userAttributes: `User's attributes`,
    userDepartments: `User's departments`,
    userEmails: `User's emails`,
    userFilters: `Contact list filters`,
    userHiringData: `User's hiring data`,
    userPermissions: `User's permissions`,
    userPhoneNumbers: `User's phone numbers`,
    userPicture: `User's pictures`,
    userPronouns: `User's pronouns`,
    userPositions: `User's positions`,
    userProcedures: `Contact list procedures`,
    userRegionalTags: `User's regions`,
    userSorts: `Contact list sorts`,
    userTeams: `User's teams`,
    users: `Users`,
    vacation: `Time off`,
    vacationModule: `Time off`
  }
}
